document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.anaphylaxis-treatment-slider')) {
        const swiper = new Swiper('.anaphylaxis-treatment-slider', {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            observer: true,
            observeParents: true,
            pagination: {
                el: '.anaphylaxis-treatment-slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.anaphylaxis-treatment-slider .swiper-button-next',
                prevEl: '.anaphylaxis-treatment-slider .swiper-button-prev',
            },
        });
    }

    document.querySelector('.custom-swiper-button-next')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-next')?.click();
    });

    document.querySelector('.custom-swiper-button-prev')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-prev')?.click();
    });

    if (document.querySelector('.anaphylaxis-safety-slider')) {
        const swiper = new Swiper('.anaphylaxis-safety-slider', {
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            pagination: {
                el: '.anaphylaxis-safety-slider .swiper-pagination',
                clickable: true,
            },
        });
    }

    // ===== Anaphylaxis LP DataLayer Events =====

    if (document.body.classList.contains('anaphylaxis-lp')) {
        let isFirstClickHandled = false;

        function getCookie(name) {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith(name + '=')) {
                    return unescape(cookie.substring(name.length + 1));
                }
            }
            return null; // Cookie not found
        }

        const buttons = document.querySelectorAll('.anaphylaxis-download-checklist-btn');

        buttons.forEach((btn) => {
            btn.addEventListener('click', function (e) {
                const position = this.dataset.position;
                if (!position) return;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: `checklist_download_position_${position}`
                });

                const cookie = getCookie('_gcl_au');
                const cookieAccepted = cookie && cookie !== '' && cookie !== '_gcl_au';

                if (cookieAccepted && !isFirstClickHandled) {
                    console.log('First click when cookie accepted');
                    isFirstClickHandled = true;
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            }, true);
        });

        const posterButtons = document.querySelectorAll('.anaphylaxis-poster-btn');

        posterButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const position = this.getAttribute('data-position');

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'anxs_poster_download',
                    place: position
                });
            });
        });
    }

    // ===== bee animation =====
    const beeSection = document.querySelector('.bee-section');
    const bee = document.getElementById('bee');
    const ctaButton = document.getElementById('cta-button');
    const debugPath = document.getElementById('debug-path');

    let hasFlown = false;

    function updateFlightPath() {
        const sectionRect = beeSection.getBoundingClientRect();
        const ctaRect = ctaButton.getBoundingClientRect();

        const ctaRelX = ctaRect.left - sectionRect.left;
        const ctaRelY = ctaRect.top - sectionRect.top;
        const ctaW = ctaRect.width;
        const ctaH = ctaRect.height;
        const sW = sectionRect.width;
        const sH = sectionRect.height;

        // Landing point: on top of the orange circle of the CTA button
        const endX = ctaRelX + ctaW - 30;
        const endY = ctaRelY - 10;

        // ===== FLIGHT PATH matching the red line from screenshot =====
        // The line goes: top-center → arcs right → S-curves down
        // along the boundary between text and document → lands on CTA

        // Start: top, slightly left of center
        const startX = sW * 0.28;
        const startY = -20;

        // Phase 1: Arc up and right toward the gap between title and document
        const cp1x = sW * 0.38;
        const cp1y = -30;
        const cp2x = sW * 0.52;
        const cp2y = -15;
        const p1x = sW * 0.54;
        const p1y = sH * 0.06;

        // Phase 2: S-curve — swing right then back left (along text/doc border)
        const cp3x = sW * 0.57;
        const cp3y = sH * 0.18;
        const cp4x = sW * 0.48;
        const cp4y = sH * 0.30;
        const p2x = sW * 0.50;
        const p2y = sH * 0.42;

        // Phase 3: Continue S — swing left then back right then left
        const cp5x = sW * 0.53;
        const cp5y = sH * 0.52;
        const cp6x = sW * 0.46;
        const cp6y = sH * 0.65;
        const p3x = sW * 0.40;
        const p3y = sH * 0.72;

        // Phase 4: Final swoop down to CTA
        const cp7x = sW * 0.34;
        const cp7y = sH * 0.78;
        const cp8x = endX + 50;
        const cp8y = endY - 30;

        const path =
            `M ${startX},${startY} ` +
            `C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p1x},${p1y} ` +
            `C ${cp3x},${cp3y} ${cp4x},${cp4y} ${p2x},${p2y} ` +
            `C ${cp5x},${cp5y} ${cp6x},${cp6y} ${p3x},${p3y} ` +
            `C ${cp7x},${cp7y} ${cp8x},${cp8y} ${endX},${endY}`;

        bee.style.offsetPath = `path('${path}')`;

        // Update debug visualization
        debugPath.setAttribute('viewBox', `0 0 ${sW} ${sH}`);
        debugPath.innerHTML = `<path d="${path}" fill="none" stroke="rgba(232,80,30,0.6)" stroke-width="2" stroke-dasharray="6 4"/>`;
    }

    function releaseBee() {
        if (hasFlown) return;
        hasFlown = true;

        updateFlightPath();
        bee.classList.add('flying');

        bee.addEventListener('animationend', function handler() {
            bee.classList.remove('flying');
            bee.classList.add('landed');
            bee.removeEventListener('animationend', handler);
        }, {once: true});
    }

// Intersection Observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasFlown) {
                setTimeout(releaseBee, 100);
            }
        });
    }, {threshold: 0.4});

    observer.observe(beeSection);

// Resize handler
    window.addEventListener('resize', () => {
        if (!hasFlown) updateFlightPath();
    });

// Initial path calculation
    updateFlightPath();
});

